// extracted by mini-css-extract-plugin
module.exports = {"serviceIcons":"styles-module--serviceIcons--1zu04"};